/* ============================================================
   Julez Bryant — Native Wishlist
   No app. No recurring fee. localStorage + optional Klaviyo.
   ------------------------------------------------------------
   Files: wishlist.js (this), wishlist.css,
          snippets/wishlist-button.liquid, snippets/wishlist-link.liquid,
          sections/wishlist-page.liquid
   ============================================================ */
(function () {
  'use strict';

  /* ---- Config ------------------------------------------------ */
  var STORAGE_KEY     = 'julez_wishlist_v1';
  var KLAVIYO_ENABLED = true;   // set to false to turn off Klaviyo events
  var CART_REDIRECT   = '/cart'; // after add-to-cart; swap for your drawer if desired

  /* ---- Storage ----------------------------------------------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
    updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }

  function add(item) {
    var items = read();
    if (!items.some(function (i) { return i.handle === item.handle; })) {
      items.push(item);
      write(items);
      klaviyo('Added to Wishlist', item);
    }
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }
  function toggle(item) {
    if (has(item.handle)) { remove(item.handle); } else { add(item); }
    return has(item.handle);
  }

  /* ---- Klaviyo ---------------------------------------------- */
  function klaviyo(event, item) {
    if (!KLAVIYO_ENABLED || typeof window._learnq === 'undefined') return;
    try {
      window._learnq.push(['track', event, {
        Name:       item.title,
        Handle:     item.handle,
        ProductID:  item.id,
        URL:        item.url,
        ImageURL:   item.image,
        Price:      item.price != null ? (item.price / 100) : null,
        WishlistSize: read().length
      }]);
    } catch (e) {}
  }

  /* ---- Header count badge ----------------------------------- */
  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* ---- Heart buttons ---------------------------------------- */
  function syncButton(btn) {
    var active = has(btn.getAttribute('data-wishlist-handle'));
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    var label = btn.querySelector('[data-wishlist-label]');
    if (label) { label.textContent = active ? 'Saved' : 'Save'; label.hidden = false; }
  }

  function bindButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-button]').forEach(function (btn) {
      if (btn.__wlBound) return;
      btn.__wlBound = true;
      syncButton(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle({
          handle: btn.getAttribute('data-wishlist-handle'),
          id:     btn.getAttribute('data-wishlist-id'),
          title:  btn.getAttribute('data-wishlist-title'),
          url:    btn.getAttribute('data-wishlist-url'),
          image:  btn.getAttribute('data-wishlist-image'),
          price:  parseInt(btn.getAttribute('data-wishlist-price'), 10) || null
        });
        syncButton(btn);
      });
    });
  }

  document.addEventListener('wishlist:updated', function () {
    document.querySelectorAll('[data-wishlist-button]').forEach(syncButton);
  });

  /* ---- Public API ------------------------------------------- */
  window.JulezWishlist = { read: read, add: add, remove: remove, toggle: toggle, has: has };

  /* ============================================================
     Wishlist page renderer
     ============================================================ */
  function money(cents) {
    if (cents == null) return '';
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
  }
  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  // Pull fresh, accurate data (price, availability, valid variant) from Shopify
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return { handle: handle, missing: true };
        var firstAvailable = (p.variants || []).find(function (v) { return v.available; });
        var variant = firstAvailable || (p.variants || [])[0] || {};
        return {
          handle:    p.handle,
          title:     p.title,
          url:       p.url || ('/products/' + p.handle),
          image:     (p.featured_image || (p.images && p.images[0]) || ''),
          price:     p.price,
          available: !!firstAvailable,
          variantId: variant.id
        };
      })
      .catch(function () { return { handle: handle, missing: true }; });
  }

  function cardHTML(p, sharedView) {
    if (p.missing) return '';
    var soldOut = p.available === false;
    return '' +
      '<article class="wl-card" data-wl-card="' + esc(p.handle) + '">' +
        '<a class="wl-card__media" href="' + esc(p.url) + '">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="wl-card__body">' +
          '<a class="wl-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="wl-card__price">' + money(p.price) + (soldOut ? ' <span class="wl-card__so">Sold out</span>' : '') + '</div>' +
          '<div class="wl-card__actions">' +
            (soldOut
              ? '<button class="wl-btn wl-btn--ghost" type="button" disabled>Sold out</button>'
              : '<button class="wl-btn wl-add" type="button" data-variant="' + esc(p.variantId) + '">Add to cart</button>') +
            (sharedView ? '' : '<button class="wl-remove" type="button" data-remove="' + esc(p.handle) + '" aria-label="Remove">Remove</button>') +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { window.location.href = CART_REDIRECT; })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; setTimeout(function () { btn.textContent = original; }, 1500); });
  }

  function initPage(container) {
    var grid     = container.querySelector('[data-wl-grid]');
    var empty    = container.querySelector('[data-wl-empty]');
    var titleEl  = container.querySelector('[data-wl-title]');
    var shareBtn = container.querySelector('[data-wishlist-share]');

    var sharedParam = getParam('shared');
    var sharedView  = !!sharedParam;
    var handles = sharedView
      ? sharedParam.split(',').map(function (h) { return h.trim(); }).filter(Boolean)
      : read().map(function (i) { return i.handle; });

    if (sharedView && titleEl) titleEl.textContent = 'A wishlist shared with you';

    function paint() {
      var current = sharedView ? handles : read().map(function (i) { return i.handle; });
      if (!current.length) {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        if (shareBtn) shareBtn.hidden = true;
        return;
      }
      if (empty) empty.hidden = true;
      grid.setAttribute('aria-busy', 'true');
      Promise.all(current.map(fetchProduct)).then(function (products) {
        grid.innerHTML = products.map(function (p) { return cardHTML(p, sharedView); }).join('');
        grid.setAttribute('aria-busy', 'false');
        if (shareBtn && !sharedView) shareBtn.hidden = false;
      });
    }

    grid.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.wl-add');
      if (addBtn) { addToCart(addBtn.getAttribute('data-variant'), addBtn); return; }
      var rmBtn = e.target.closest('.wl-remove');
      if (rmBtn) { remove(rmBtn.getAttribute('data-remove')); paint(); }
    });

    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var hs = read().map(function (i) { return i.handle; });
        if (!hs.length) return;
        var url = window.location.origin + window.location.pathname + '?shared=' + encodeURIComponent(hs.join(','));
        if (navigator.share) {
          navigator.share({ title: 'My Julez Bryant wishlist', url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var t = shareBtn.textContent; shareBtn.textContent = 'Link copied ✓';
            setTimeout(function () { shareBtn.textContent = t; }, 1800);
          });
        } else {
          prompt('Copy your wishlist link:', url);
        }
      });
    }

    if (!sharedView) document.addEventListener('wishlist:updated', paint);
    paint();
  }

  /* ---- Boot ------------------------------------------------- */
  function boot() {
    updateCount();
    bindButtons();
    var page = document.querySelector('[data-wishlist-page]');
    if (page) initPage(page);
    var mo = new MutationObserver(function () { bindButtons(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();